import React, { useState, useRef, useEffect } from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import withStyles from "@material-ui/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import GetAppIcon from "@material-ui/icons/GetApp";
import DateFnsUtils from "@date-io/date-fns";
import {DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import api from "../../common/api";
import CircularProgress from "@material-ui/core/CircularProgress";
import html2canvas from "html2canvas";
import useFromValidator from '../../common/formValidator';
import { useReactToPrint } from 'react-to-print';
import {useGlobalState} from '../../state';
import { changeToLocalString } from '../../common/functions';

import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TableWrapper from "../../components/Table/TableWrapper";
import { generateReportTitle } from "./utils/functions";
window.html2canvas = html2canvas;

const schema = {    
    entryDate:{
        presence: {allowEmpty: false, message: 'is required'}
    }
};

const useStyles = makeStyles(theme => ({
  root: props => ({
    margin: props.isDesktop ? theme.spacing(4) : theme.spacing(1)
  }),
  topBar: {
    marginBottom: theme.spacing(2)
  },
  link: {
    display: "flex"
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20
  },
  formControl: {
    width: "100%"
  },
  progressContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%"
  },
  progressBar: {
    margin: theme.spacing(2)
  },
  singleLineBorder: {
    borderTop: "solid 1px #F26522",
    borderBottom: "solid 1px #F26522"
  },
  doubleLineBorder: {
    borderTop: "double #F26522",
    borderBottom: "double #F26522"
  },
  singleLineBorderGroup: {
   borderBottom: "solid 1px #F26522",
   borderTop: "solid 1px #F26522",
  },
  singleLineBorderGroupTop: {
     borderTop: "solid 1px #F26522",
     borderBottom: "solid 1px #F26522",
  },
  reportContainer: {},
  reportHeader: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  rawBatchName: {
    textAlign: "center",
    textDecoration: "underline"
  },
  tableHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
    stdData : {
        color:"#4999db",
        marginLeft:'1px',
        fontSize:"10px",
    }
}));

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding:"4px",
    overflow: "hidden", 
    fontSize:"12px",
    width:"77px"  },
  body: {
    //fontSize: "1em",
    backgroundColor: theme.palette.common.white,
    padding:"4px",
    overflow: "hidden", 
    fontSize:"12px",
    width:"77px"  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    },
    "&:last-child td": {
      borderTop: "double "+ theme.palette.warning.dark,
      borderBottom: "double "+ theme.palette.warning.dark,
    }
  }
}))(TableRow);


const generateExcel = function(header, data, reportOptions, fileName="report") {
  let csvData = "";
  header.forEach((column, index) => {
    if (index === 0) csvData = csvData + column;
    else csvData = csvData + "," + column;
  });
  csvData = csvData + "\r\n";

  // process data rows
  data.forEach(row => {
    if (row[0] === "" && row[1] !== "") {
      // Handle section header rows
      csvData = csvData + row[1] + "\r\n";
      return;
    }

    let rowData = [];
    
    // default columns (always included)
    rowData.push(row[1] || ""); // Shed
    rowData.push(row[2] || ""); // Age (in weeks)
    rowData.push(row[3] || ""); // Production %

    // good Egg %, Broken Egg %, Damaged Egg % based on truckEggsView
    rowData.push(reportOptions.truckEggsView ? (row[15] || "") : (row[4] || "")); // Good Egg %
    rowData.push(reportOptions.truckEggsView ? (row[16] || "") : (row[5] || "")); // Broken Egg %
    rowData.push(reportOptions.truckEggsView ? (row[17] || "") : (row[6] || "")); // Damaged Egg %
    
    // regular columns
    rowData.push(row[7] || ""); // Feed/bird in grams
    rowData.push(row[8] || ""); // Feedin grams per EGG
    rowData.push(row[9] || ""); // Egg/bag
    rowData.push(row[10] || ""); // Mortality

    // Add Standard Data if enabled
    if (reportOptions.stdData) {
      rowData.push(row[11] || ""); // Std Egg %
      rowData.push(row[12] || ""); // Std.Feed/bird in grams
    }

    // Add Difference Data if enabled
    if (reportOptions.diffData) {
      rowData.push(row[13] || ""); // Diff. Egg Production
      rowData.push(row[14] || ""); // Diff. Feed/grams
    }
    // medicine column
    if (reportOptions.medicineView) {
      rowData.push(row[18].replace(/[\r\n]+/g, ' | ') || ""); // medicine column
    }

    // Join row data with commas
    csvData = csvData + rowData.join(",") + "\r\n";
  });
 if (window?.ReactNativeWebView) {
  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type: "download-csv",
      name: `${fileName}.csv`,
      data: csvData,
    })
  );
 } else {

   var element = document.createElement("a");
   element.setAttribute(
     "href",
     "data:text/csv;charset=utf-8," + encodeURIComponent(csvData)
   );
   element.setAttribute("download", `${fileName}.csv`);
  
   element.style.display = "none";
   document.body.appendChild(element);
  
   element.click();
  
   document.body.removeChild(element);
 }

};

const AllBatchDaily = ({ showError, match }) => {
  const theme = useTheme();
  const [{user}] = useGlobalState();
  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState(false);
  const [data, setData] = useState([]);
    const [entryDate, setEntryDate] = useState(null);
    const [reportFileName, setReportFileName] = useState("");

  const [formState, hasError, handleChange] = useFromValidator(schema);

  const [column, setColumn] = useState({
    stdData: false,
    diffData: false,
    truckEggsView: user?.Config?.truckeggs_as_goodEggs || false,
    medicineView: false,
  })

  const tableHeader = useRef(JSON.parse(`[["Shed","Age(in Weeks)","Production %","Good Egg %","Broken Egg %","Damaged Egg %",
    "Feed/bird in grams","Feedin gm/Egg","Egg/bag","Mortality","Age(in Weeks)"
  ]]`))

  useEffect(() => {
    tableHeader.current = JSON.parse(
      `[[
        "Shed","Age(in Weeks)","Production %","Good Egg %","Broken Egg %","Damaged Egg %",
        "Feed/bird in grams","Feedin gm/Egg","Egg/bag","Mortality"
        ${column.stdData ? ',"Std Egg %","Std.Feed/bird in grams"' : ''}
        ${column.diffData ? ',"Diff. Egg Production","Diff. Feed/grams"' : ''}
        ${column.medicineView ? ',"Medicine and Vaccination"' : ''}
      ]]`
    )
  }, [column]);

  const parseReportFromServer = function(data) {
    const { reportsArray } = data;
    setData(reportsArray);
    console.log(data);
  };

  //Dynamic Report based on TruckView Switch
  const  truckDynamicReport = function(truckEggsView, row, defaultIndex,truckViewindex, amountObj) {
    if (truckEggsView) {
        return row[truckViewindex] ? changeToLocalString(row[truckViewindex], amountObj) : "";
    } else {
        return row[defaultIndex] ? changeToLocalString(row[defaultIndex], amountObj) : "";
    }
  }
  const generateReport = function() {
    showError("");
    setLoading(true);
    const payload = {
      //batchID: batches[batchIndex].id
      farmID: parseInt(match.params["farmID"]),
      date: formState.values.entryDate
    };

    const response = api.post("reports/all-batch-daily", payload);

    response
      .then(res => {
        parseReportFromServer(res);

        setReportFileName(generateReportTitle({date:formState.values.entryDate, reportName: "AllBatchDaily"}));
      })
      .catch(err => {
        if (err.message) {
          if (err.message === "Bad Request" || err.message === "No data found")
            showError(err.message);
        } else {
          showError("Unknown Error");
        }
      })
      .finally(() => {
        setLoading(false);
        setEntryDate(new Date(payload.date))
      });
  };

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true
  });
  const classes = useStyles({ isDesktop });

  const componentRef = useRef();
  const generatePDF = useReactToPrint({
      content: () => componentRef.current,
      documentTitle: reportFileName,
      pageStyle: `
      @media print {
        @page {
          size: landscape !important;
          margin: 0;
        }
      }`,
    });

  const amountObj = {
       /* style: "currency",
        currency: user.currency,*/
        locales: user.locales,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }

  return (
    <div className={classes.root}>
      <Grid container alignItems="flex-start" className={classes.topBar}>
        <Grid>
          <Typography display="block" variant="h3" gutterBottom>
            All Batch KPI Report 
          </Typography>
        </Grid>
      </Grid>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={3} justify="flex-start" alignItems="center">
          <Grid item>
                <DatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Entry Date"
                    format="dd/MM/yyyy"
                    value={formState.values.entryDate || null}
                    onChange={data => {
                        setValid(true);
                        handleChange({target: {name: 'entryDate', value: data}});
                    }}
                    onFocus={e => e.target.blur()} 
                    animateYearScrolling
                    name="entryDate"
                    error={hasError('entryDate')}
                />
          </Grid>
          <Grid item>
            <Button
              disabled={!valid}
              variant="contained"
              color="primary"
              onClick={generateReport}
            >
              Generate
            </Button>
          </Grid>
          <Grid item>
            { !(window?.ReactNativeWebView) ? 
              <Button
                disabled={!valid || data.length < 1}
                variant="outlined"
                color="primary"
                onClick={() => {
                  generatePDF();
                }}
                endIcon={<PictureAsPdfIcon />}
              >
                Download PDF
              </Button> :""
            }
          </Grid>
          <Grid item>
            <Button
              disabled={!valid || data.length < 1}
              variant="outlined"
              color="primary"
              onClick={() => generateExcel(tableHeader.current, data, column, reportFileName)}
              endIcon={<GetAppIcon />}
            >
              Download Excel
            </Button>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
      <br />
      <div>
        <FormControlLabel
          control={
            <Switch
              checked={column.stdData}
              onChange={() => setColumn({
                ...column,
                stdData: !column.stdData
              })}
              color="primary"
            />
          }
          label="Std Data"
        />
        <FormControlLabel
          control={
            <Switch
              checked={column.diffData}
              onChange={() => setColumn({
                ...column,
                diffData: !column.diffData
              })}
              color="primary"
            />
          }
          label="Difference Data"
        />
        <FormControlLabel
          control={
            <Switch
              checked={column.truckEggsView}
              onChange={() => setColumn({
                ...column,
                truckEggsView: !column.truckEggsView
              })}
              color="primary"
            />
          }
          label="Truck Eggs (Broken & Damage) in Good Eggs"
        />
        <FormControlLabel
          control={
            <Switch
              checked={column.medicineView}
              onChange={() => setColumn({
                ...column,
                medicineView: !column.medicineView
              })}
              color="primary"
            />
          }
         label="Medicine and Vaccination"
        />
      </div>
      {loading ? (
        <div className={classes.progressContainer}>
          <CircularProgress className={classes.progressBar} />
        </div>
      ) : (
        <div id="report-container" className={classes.reportContainer} ref={componentRef}>
          <div className={classes.reportHeader}>
            <Typography
              variant="h4"
              component="h4"
              className={classes.rawBatchName}
            >
                All Batch Daily Report {entryDate !== null ? "" + (entryDate.getDate()) + "/"+(entryDate.getMonth()+1) + "/" + entryDate.getFullYear() : ""}
            </Typography>
          </div>
          <TableWrapper enableKeyboardNavigation={true} focus={data && data.length > 0}>
          <Table style={{ tableLayout: "fixed"}} stickyHeader aria-label="sticky table">
            <TableHead className={classes.tableHeader} >
              <StyledTableRow>
              <StyledTableCell>Shed</StyledTableCell>
                 <StyledTableCell>Age (in weeks)</StyledTableCell>
                <StyledTableCell>Production %</StyledTableCell>
                <StyledTableCell>Good Egg %</StyledTableCell>
                <StyledTableCell>Broken Egg %</StyledTableCell>
                <StyledTableCell>Damaged Egg %</StyledTableCell>
                <StyledTableCell>Feed/bird in grams</StyledTableCell>
                 <StyledTableCell>Feedin gm/egg</StyledTableCell>
                <StyledTableCell>Egg/bag</StyledTableCell>
                <StyledTableCell>Mortality</StyledTableCell>
                {
                  (column.diffData) && 
                  <>
                      <StyledTableCell>Diff. Egg Production</StyledTableCell>
                      <StyledTableCell>Diff. Feed/grams</StyledTableCell>
                  </>
                }
                 {
                  (column.medicineView) &&
                  <>
                    <StyledTableCell>Medicine / Vaccination</StyledTableCell>
                  </>
                }
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => {
                if (row[0] === "" && row[1] !== "" ) {
                  return(
                    <StyledTableRow key={index}>
                       <StyledTableCell className={classes.singleLineBorderGroupTop} colSpan={6} style={{ fontWeight: "bold" }} align="left">
                        {row[1] ? row[1] : ""}
                      </StyledTableCell>
                      <StyledTableCell className={classes.singleLineBorderGroupTop} colSpan={4 + (column.diffData ? 2 : 0) + (column.medicineView ? 1 : 0)} style={{ fontWeight: "bold" }} align="left">
                        Group Batch
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                }else {
                  return (

                  <StyledTableRow key={index}>
                    <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} style={{ fontWeight: "bold" }} align="left" rows={4}>
                      {row[1] ? row[1] : ""}
                    </StyledTableCell>
                 
                  <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">
                    { row[2]}                    
                    </StyledTableCell>
                    
                    <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">
                    { row[3] ? changeToLocalString(row[3], amountObj) : ""}   
                      {
                       (column.stdData) && row[3]  ?

                        <span className={classes.stdData}>
                          ({row[11] ? changeToLocalString(row[11], amountObj) : ""})
                         </span> :""
                    }
                    </StyledTableCell>
                    <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left"> 
                    {truckDynamicReport(column.truckEggsView,row,4,15,amountObj)}   
                    </StyledTableCell>
                    <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left"> 
                    {truckDynamicReport(column.truckEggsView,row,5,16,amountObj)}  
                    </StyledTableCell>
                    <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">
                    {truckDynamicReport(column.truckEggsView,row,6,17,amountObj)}  
                    </StyledTableCell>
                    
                    <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">
                    { row[7] ? changeToLocalString(row[7], amountObj) : ""}          
                     {
                       (column.stdData) && row[7]  ?

                        <span className={classes.stdData}>
                          ({row[12] ? changeToLocalString(row[12], amountObj) : ""})
                         </span> :""
                    }          
                    </StyledTableCell>
                    <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">
                    { row[8] ? changeToLocalString(row[8], amountObj) : ""}                    
                    </StyledTableCell>
                    <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">
                    { row[9] ? changeToLocalString(row[9], amountObj) : ""}                    
                    </StyledTableCell>
                    <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">
                    { row[10] ? changeToLocalString(row[10], amountObj) : ""}                    
                    </StyledTableCell>
  
                    {
                    (column.diffData) && 
                      <>
                      <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">
                      { row[13] ? changeToLocalString(row[13], amountObj) : ""}                    
                      </StyledTableCell>
                      <StyledTableCell className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">
                      { row[14] ? changeToLocalString(row[14], amountObj) : ""}                    
                      </StyledTableCell>
                      </>
                    } 
                    {
                      (column.medicineView)  ?
                          <StyledTableCell  className={row[1] === "Group Total" ? classes.singleLineBorderGroup : ""} align="left">

                            <span>
                                {row[18]?.split('\n').map((item, i) => (
                                <div key={i}>{item}</div>
                              ))}
                              </span>
                         </StyledTableCell>
                         :""
                    }
                  </StyledTableRow>
                  )
                }
              })}
            </TableBody>
          </Table>
          </TableWrapper>
        </div>
      )}
    </div>
  );
};

export default AllBatchDaily;
